import { AnalysisResult } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function get(
  analysisResultGuid: string,
  sharedComponentSetLookupCode: string | undefined,
  cancellationPromise: Promise<void>,
): Promise<AnalysisResult> {
  return DesignService.get(`analysisResults/${analysisResultGuid}`, {
    params: sharedComponentSetLookupCode ? new URLSearchParams({ sharedComponentSetLookupCode }) : undefined,
    cancellationPromise,
  });
}
